import { IUsageSummary } from '@/domain/common'

export const isFetchingSummary = (state: any, isFetchingSummary: boolean) => {
    state.isFetchingSummary = isFetchingSummary;
}

export const summarySecurityLogs = (state: any, summarySecurityLogs: IUsageSummary | null) => {
    state.summarySecurityLogs = summarySecurityLogs;
}

export const summaryError = (state: any, summaryError: string) => {
    state.summaryError = summaryError;
}
